import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sent-disable-modal',
  templateUrl: './sent-disable-modal.component.html',
  styleUrls: ['./sent-disable-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SentDisableModalComponent {

  constructor(
    public dialogRef: MatDialogRef<SentDisableModalComponent>
  ) { }


}
